import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Message, SpinnerService } from 'shared-components';
import { AdminContextService } from '../../../context/admin-contex.service';
import { AdminService } from '../../../services/admin.service';

@Component({
    selector: 'app-lic-historial',
    templateUrl: './historial-activaciones.component.html'
})
export class LicHistorialActivacionesComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _licenciaHistorial;
    public licenciaHistorial;

    public showError: boolean;
    public mensajes = new Array<Message>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    @Input() licenciaId: number;
    @Input() userName: string;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService,
        private readonly _adminContext: AdminContextService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this._adminContext.gestionLicenciasHistoryFilters = null;
        this.getLicenciaHistorialActivaciones();
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public pageChange(page) {
        this._adminContext.gestionLicenciasHistoryFilters.numPagina = this.currentPage = page - 1;
        this.getLicenciaHistorialActivaciones();
    }

    public itemsPerPageChange(items) {
        this._adminContext.gestionLicenciasHistoryFilters.numPagina = this.currentPage = 0;
        this._adminContext.gestionLicenciasHistoryFilters.tamPagina = this.itemsPerPage = items;
        this.getLicenciaHistorialActivaciones();
    }

    private applyFilters() {
        this._adminContext.gestionLicenciasHistoryFilters = {
            licenciaSwId: this.licenciaId,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        };
    }

    public getLicenciaHistorialActivaciones() {
        this.applyFilters();
        this._licenciaHistorial = this._adminContext.gestionLicenciasHistoryFilters;
        this._spinnerService.showSpinner();
        this._adminService.getHistorialActivacionesLicencia(this._licenciaHistorial).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.licenciaHistorial = resp.lista;
        });
    }

    public close() {
        this.refresh.emit(false);
    }
}
